import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgViewAxisIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 2,
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "m12 3 9 5v8l-9 5-9-5V8ZM12 3v9" }), /* @__PURE__ */ _jsx("path", { d: "m3 8 9 4 9-4" })]
});
export default SvgViewAxisIcon;
